import React, { Component, Fragment } from 'react'
import List from './List'
import { HeaderView } from '@merchant-backend/common-components'
import store from './store'
import { observer } from 'mobx-react'
import { Pagination } from 'hljd'

@observer
export default class extends Component {
  componentDidMount() {
    store.getList()
  }
  render() {
    const { list, total, current } = store
    let title = [
      <a href="#/localMerchant/settlementManage">结算管理</a>,
      '账单列表'
    ]

    return (
      <HeaderView title="账单列表" header={title}>
        {list.length > 0 ? (
          <Fragment>
            {list.map((item, index) => <List key={index} data={item} />)}

            <Pagination
              current={current}
              total={total}
              onChange={store.setPagination}
              style={{ marginBottom: 20 }}
            />
          </Fragment>
        ) : (
          <p
            style={{
              textAlign: 'center',
              margin: 20,
              minHeight: 400,
              fontSize: 16
            }}
          >
            暂无历史账单
          </p>
        )}
      </HeaderView>
    )
  }
}
